module.exports = __webpack_public_path__ + "images/suite_wifi.webp";